import React from 'react';
import { CardTextBox } from '../../CardComponents/card-text-box/component.js'; // To keep things DRY, splitting this off to a component

var TextBox = function TextBox(_ref) {
  var cardProps = _ref.cardProps,
      cardEffects = _ref.cardEffects;
  var alertMiniCard = cardProps.alertMiniCard,
      allowSecondaryDetailLineBreaks = cardProps.allowSecondaryDetailLineBreaks,
      attentionGrabber = cardProps.attentionGrabber,
      descriptionDataAttributes = cardProps.descriptionDataAttributes,
      dismissable = cardProps.dismissable,
      title = cardProps.title,
      titleSize = cardProps.titleSize,
      titleIcon = cardProps.titleIcon,
      titleIconSize = cardProps.titleIconSize,
      type = cardProps.type,
      description = cardProps.description,
      descriptionClass = cardProps.descriptionClass,
      secondaryDetail = cardProps.secondaryDetail,
      titleDataAttributes = cardProps.titleDataAttributes,
      hasRichTextContent = cardProps.hasRichTextContent,
      _cardProps$styleConfi = cardProps.styleConfig,
      styleConfig = _cardProps$styleConfi === void 0 ? {
    corner: 'none'
  } : _cardProps$styleConfi;

  var _ref2 = styleConfig || {},
      corner = _ref2.corner; // default values are set in the presentation-card component


  var hasLabel = cardEffects.hasLabel,
      hasMedia = cardEffects.hasMedia;
  return /*#__PURE__*/React.createElement(CardTextBox, {
    "data-component-type": "presentation-card-text-box",
    chakra: 'on' // TODO remove with legacy card removal
    ,
    alertMiniCard: alertMiniCard,
    allowSecondaryDetailLineBreaks: allowSecondaryDetailLineBreaks,
    attentionGrabber: attentionGrabber,
    corner: corner,
    descriptionDataAttributes: descriptionDataAttributes,
    dismissable: dismissable,
    title: title,
    titleSize: titleSize,
    titleIcon: titleIcon,
    titleIconSize: titleIconSize,
    type: type,
    description: description,
    descriptionClass: descriptionClass,
    secondaryDetail: secondaryDetail,
    titleDataAttributes: titleDataAttributes,
    hasLabel: hasLabel,
    hasMedia: hasMedia,
    hasRichTextContent: hasRichTextContent
  });
};

TextBox.displayName = "TextBox";
export { TextBox };